import { cardImageOffset } from '@squareup/dex-ui-shared-markdown-card';
import React, { FC, PropsWithChildren } from 'react';

const MdxCardImageOffset: FC<PropsWithChildren> = ({ children }) => {
  const Component = cardImageOffset.component.value;
  return <Component>{children}</Component>;
};

MdxCardImageOffset.displayName = 'MdxCardImageOffset';

export { MdxCardImageOffset };
